export const capitaliseFirstLetter = (string: any) => string?.charAt(0).toUpperCase() + string?.slice(1);

export const convertUnitAmountToAmount = (unitAmountDecimal: any) => {
    const amount = unitAmountDecimal / 100;
    return amount.toFixed(2);
}